import type { PriceHistory } from '@api';
import { getPriceChange } from '@terminal/widgets/asset-overview-widget/utils/asset-box/asset-box-helpers';

export const endOfDayUTC = (date: Date) => {
  const copy = new Date(date);
  copy.setUTCHours(23, 59, 59, 999);
  return copy;
};

const getUTCDate = (date: Date) => date.toISOString().split('T')[0];

export const getFrozenCatalystPriceChange = (
  history: PriceHistory | undefined,
  publicationDate: Date
) => {
  if (!history || history.length < 2) {
    return undefined;
  }

  const publicationDateKey = getUTCDate(publicationDate);
  const catalystCloseIndex = history.findLastIndex(
    point => getUTCDate(new Date(point.time)) <= publicationDateKey
  );

  if (catalystCloseIndex <= 0) {
    return undefined;
  }

  const catalystClose = history[catalystCloseIndex];
  const previousClose = history[catalystCloseIndex - 1];

  return getPriceChange({
    lastPrice: previousClose.close,
    newPrice: catalystClose.close,
  }).priceChange;
};
